import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';

const JsonAnimation = ({ jsonFile, style }) => {
  const animation = useRef(null);
  useEffect(() => {
    lottie.loadAnimation({
      container: animation.current,
      render: 'svg',
      loop: false,
      autoplay: true,
      animationData: jsonFile,
    });

    return () => lottie.stop();
  }, []);
  return <div ref={animation} style={style} />;
};

export default JsonAnimation;
JsonAnimation.propTypes = {
  jsonFile: PropTypes.any.isRequired,
  style: PropTypes.any.isRequired,
};
